angular.module("app").constant("casinoJackpot", [{
    key: "No Jackpot",
    value: "0"
}, {
    key: "Global",
    value: "1"
},{
    key: "Network",
    value: "2"
}, {
    key: "Local",
    value: "3"
}]);

angular.module("app").constant("jackpotSources", [{
    key: "No Jackpot",
    value: ""
}, {
    key: "Betconstruct",
    value: "28"
}]);
